<template>
<div class="navbar">
  <div>
    <img class="logo" src="/logo.svg">
  </div>
  <div class="logout-button" @click="logout">
    Cerrar sesión
    <img class="logout" src="/logout.svg">
  </div>
</div>
</template>

<script>
import axios from 'axios';
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('user');
export default {
  methods: {
    logout() {
      localStorage.removeItem('token');
      this.$router.push('/login');
    },
    ...mapActions([
      'getUser',
    ]),
  },
  mounted() {
    const token = localStorage.getItem('token');
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    if (!token) {
      this.$router.push('/login');
    }
    this.getUser().catch(() => {
      localStorage.removeItem('token');
      this.$router.push('/login');
    });
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  background-color: white;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  height: 60px;
  align-items: center;
  padding: 0 20px;
}
.logo {
  height: 80px;
  margin-left: -10px;
  margin-top: -8px;
}
.logout-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #f79916;

  img {
    height: 20px;
    width: auto;
    margin-left: 12px;
  }
}
</style>
